import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import {
  FaArrowUp,
  FaChevronDown,
  FaFacebookF,
  FaInstagram,
  FaRegHandshake,
  FaTimes,
} from "react-icons/fa";
import "./Footer.css";

/* Link groups: on phones each becomes an accordion (closed by
   default); on desktop they are always open (Footer.css). */
const FOOTER_GROUPS = [
  {
    key: "explore",
    label: "Explore",
    links: [
      { to: "/hub", label: "Home" },
      { to: "/HubMart", label: "HubMart" },
      { to: "/connect", label: "Community Connect" },
      { to: "/forum", label: "Community Forum" },
    ],
  },
  {
    key: "company",
    label: "Company",
    links: [
      { to: "/about-us", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/dashboard", label: "My Dashboard" },
      { to: "/review-system", label: "Reviews & Ratings" },
      { to: "/partner-signup#joinForm", label: "List your business", hash: true },
    ],
  },
  {
    key: "legal",
    label: "Legal",
    links: [
      { to: "/terms", label: "Terms of Service" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/contact", label: "Support" },
    ],
  },
];

function Footer() {
  const [showReferModal, setShowReferModal] = useState(false);
  const [openGroup, setOpenGroup] = useState(null);
  const year = new Date().getFullYear();

  useEffect(() => {
    const onEscape = (event) => {
      if (event.key === "Escape") setShowReferModal(false);
    };

    document.addEventListener("keydown", onEscape);
    document.body.classList.toggle("goh-modal-open", showReferModal);

    return () => {
      document.removeEventListener("keydown", onEscape);
      document.body.classList.remove("goh-modal-open");
    };
  }, [showReferModal]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footerSection goh-footer">
      <button type="button" className="goh-footer__top" onClick={scrollToTop}>
        <FaArrowUp />
        <span>Back to top</span>
      </button>

      <div className="goh-footer__shell">
        <div className="goh-footer__cta">
          <div>
            <p className="goh-footer__eyebrow">Support local. Find local. Grow together</p>
           
            
          </div>

          <div className="goh-footer__cta-actions">
            <HashLink smooth to="/partner-signup#joinForm" className="goh-footer__btn goh-footer__btn--primary">
              List your business free
            </HashLink>
          </div>
        </div>

        <div className="goh-footer__grid">
          <section className="goh-footer__brand">
         
         

            <div className="goh-footer__social" aria-label="Social links">
              <a
                href="https://www.facebook.com/profile.php?id=61560982405400"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/goourhub/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </section>

          {FOOTER_GROUPS.map((group) => {
            const open = openGroup === group.key;

            return (
              <nav
                key={group.key}
                className={`goh-footer__col ${open ? "is-open" : ""}`}
                aria-label={`${group.label} links`}
              >
                <h4>
                  <button
                    type="button"
                    className="goh-footer__acc"
                    aria-expanded={open}
                    aria-controls={`goh-footer-${group.key}`}
                    onClick={() =>
                      setOpenGroup((current) => (current === group.key ? null : group.key))
                    }
                  >
                    {group.label}
                    <FaChevronDown aria-hidden="true" />
                  </button>
                </h4>

                <div className="goh-footer__links" id={`goh-footer-${group.key}`}>
                  {group.links.map((link) =>
                    link.hash ? (
                      <HashLink key={link.label} smooth to={link.to}>
                        {link.label}
                      </HashLink>
                    ) : (
                      <Link key={link.label} to={link.to}>
                        {link.label}
                      </Link>
                    )
                  )}
                </div>
              </nav>
            );
          })}
        </div>

        <div className="goh-footer__bottom">
          <span>© GoOurHub {year}. All rights reserved.</span>
          <div className="goh-footer__bottom-links">
            <Link to="/contact">Contact</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>

      {showReferModal && (
        <div className="goh-footer-modal" role="dialog" aria-modal="true" aria-labelledby="goh-refer-title">
          <div className="goh-footer-modal__backdrop" onClick={() => setShowReferModal(false)} />
          <div className="goh-footer-modal__card">
            <button
              type="button"
              className="goh-footer-modal__close"
              onClick={() => setShowReferModal(false)}
              aria-label="Close referral modal"
            >
              <FaTimes />
            </button>

            <div className="goh-footer-modal__icon">
              <FaRegHandshake />
            </div>
            <p className="goh-footer-modal__eyebrow">Referral Program</p>
            <h3 id="goh-refer-title">Bring a business into the network</h3>
            <p>
              Know a business, creator, or organization that should be on GoOurHub? Send them our way and help grow the ecosystem.
            </p>

            <div className="goh-footer-modal__actions">
              <HashLink
                smooth
                to="/partner-signup#joinForm"
                className="goh-footer__btn goh-footer__btn--primary"
                onClick={() => setShowReferModal(false)}
              >
                Send Them to Join
              </HashLink>
              <Link
                to="/contact"
                className="goh-footer__btn goh-footer__btn--secondary"
                onClick={() => setShowReferModal(false)}
              >
                Contact the Team
              </Link>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
